/**
 * AdsPlatformToggle — переключатель платформы раздела «Реклама»
 * ==============================================================
 *
 * Один на весь раздел, стоит над вкладками (в AdsSectionFilters). Пишет в общий фильтр платформы
 * дашборда (тот же, что в сайдбаре), поэтому все вкладки получают его через
 * `filters.platform` и перезапрашивают данные сами.
 * 'all' = GP + iOS: параметр `platform` на сервер не уходит (см. toAdsParams).
 */

import React from 'react';
import { useFilters } from '../../../hooks/useFilters';
import { ToggleGroup, ToggleGroupItem } from '../../ui/toggle-group';

const PLATFORM_OPTIONS = [
  { value: 'android', label: 'GP' },
  { value: 'ios', label: 'iOS' },
  { value: 'all', label: 'GP + iOS' }
];

export function AdsPlatformToggle() {
  const { platform, setPlatform } = useFilters();
  const current = platform === 'android' || platform === 'ios' ? platform : 'all';

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-muted-foreground">Платформа</span>
      <ToggleGroup
        type="single"
        size="sm"
        value={current}
        onValueChange={(value) => value && setPlatform(value)}
      >
        {PLATFORM_OPTIONS.map((opt) => (
          <ToggleGroupItem key={opt.value} value={opt.value} aria-label={opt.label} className="text-xs px-3">
            {opt.label}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </div>
  );
}

export default AdsPlatformToggle;
